import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RepaymentsService {
  authToken: any;
  user: any;
  baseURI: any;

  constructor(private http: HttpClient, private auth: AuthService) {
    this.baseURI = this.auth.baseURL;
  }

  loadToken() {
    const token = localStorage.getItem('bUser_token');
    this.authToken = token;
    const user = localStorage.getItem('user');
    this.user = user;
  }

  RepaymentbyCommodity(params = {}) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.get(this.baseURI + `reports/loan/repayment/commodity`, {
      // headers: headers,
      params,
    });
  }

  RepaymentbyBorrower(obj) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.post(
      this.baseURI + `reports/loan/repayment/borrower`,
      obj,
      // { headers: headers }
    );
  }

  RepaymentbyUser(obj) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.post(
      this.baseURI + `reports/loan/repayment/user-type`,
      obj,
      // { headers: headers }
    );
  }

  RepaymentbyCma(obj) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.post(this.baseURI + `reports/loan/repayment/cma`, obj,
      // { headers: headers }
    );
  }

  RepaymentbyCommodityWhr(obj) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.post(
      this.baseURI + `reports/loan/repayment/commodity/whr`,
      obj,
      // { headers: headers }
    );
  }

  RepaymentbyWhrLoans(obj) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.post(
      this.baseURI + `reports/loan/repayment/whr/loans`,
      obj,
      // { headers: headers }
    );
  }

  RepaymentbyUserTypeWhr(obj) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.post(
      this.baseURI + `reports/loan/repayment/user-type/whr`,
      obj,
      // { headers: headers }
    );
  }

  addRepaymentDetails(data) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.post(
      this.baseURI + 'reports/loan/repayment/application',
      data,
      // { headers: headers }
    );
  }

  getRepayment(id, uId) {
    // console.log('sasas',this.baseURI + `reports/loan/repayment/details/${id}/${uId}`);
    // this.loadToken();
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    // console.log('headers', headers);
    return this.http.get(
      this.baseURI + `reports/loan/repayment/details/${id}/${uId}`,
      // { headers: headers }
    );
  }

  getRepaymentById(id) {
    // console.log('sasas',this.baseURI + `reports/loan/repayment/details/${id}/${uId}`);
    // this.loadToken();
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    // console.log('headers', headers);
    return this.http.get(this.baseURI + `reports/loan/repayment/${id}`);
  }

  repaymentByWarehouses(params) {
    // this.loadToken();
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');

    return this.http.get(this.baseURI + `reports/loan/repayment/warehouses`, {
      // headers: headers,
      params,
    });
  }

  repaymentByApplicants(params) {
    // this.loadToken();
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');

    return this.http.get(this.baseURI + `reports/loan/repayment/applicants`, {
      // headers: headers,
      params,
    });
  }

  repaymentReport(params) {
    //this.loadToken();
    // console.log(params,'sspsps',this.authToken)
    // let headers: HttpHeaders = new HttpHeaders();
    //headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.get(this.baseURI + `reports/loan/repayment`, {
      // headers: headers,
      params,
    });
  }
}
